import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	somethingWrong: {
		id: 'users-and-roles.actors-table.table-error-view.something-wrong',
		defaultMessage: "Something's gone wrong",
		description: 'Header message when a table error occurs.',
	},
	pageLoadPrevented: {
		id: 'users-and-roles.actors-table.table-error-view.page-load-prevented',
		defaultMessage: 'A problem prevented the page from loading.',
		description: 'First line of generic message when something goes wrong.',
	},
	tryAgain: {
		id: 'users-and-roles.actors-table.table-error-view.try-again',
		defaultMessage: 'Refresh and try again.',
		description: 'Second line of generic message when something goes wrong.',
	},
	refresh: {
		id: 'users-and-roles.actors-table.table-error-view.refresh',
		defaultMessage: 'Refresh',
		description: 'Text for refresh button',
	},
});
